import { ontruckApi } from './instances';

const getPricingVersions = async (strategy = 'ES_SH') => {
  const {
    data: { results: pricingVersions }
  } = await ontruckApi.get(`pricing/price_engine/base_config/?strategy=${strategy}`);
  return pricingVersions;
};

const getCurrentPricingVersion = async (strategy = 'ES_SH') => {
  const {
    data: { results: currentList }
  } = await ontruckApi.get(
    `pricing/price_engine/actual_base_config/?strategy=${strategy}&page_size=1`
  );

  return currentList[0] ? currentList[0] : {};
};

const getCurrentPricingVersionDetail = async (strategy = 'ES_SH') => {
  const { tag } = await getCurrentPricingVersion(strategy);
  const { data } = await ontruckApi.get(`pricing/price_engine/base_config/${tag}/`);
  return data;
};

const postPricingVersion = async data => {
  return await ontruckApi.post(`pricing/price_engine/base_config/`, data);
};

const putPricingVersion = async version => {
  return await ontruckApi.post(`pricing/price_engine/actual_base_config_journal/`, {
    base_price_config_id: version
  });
};

export {
  getCurrentPricingVersion,
  putPricingVersion,
  getPricingVersions,
  getCurrentPricingVersionDetail,
  postPricingVersion
};
